module.exports = __webpack_public_path__ + "static/img/hot-animation.9862a28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/hot-animation.png
// module id = L6Ky
// module chunks = 2